import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/InventoryTransferReport/Filter'

export default createListViewComponent({
  entityName: entityNames.inventoryTransferReport,
  filterTemplateType: 'InventoryTransferReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
